export const pageFinder = (pages, pageName, functioName) => {
  const page = pages[functioName].edges.find(n => {
    return n.node.Name.includes(pageName)
  })
  if (!page) {
    return null
  }
  return page.node
}
